import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormArray, ValidatorFn, AbstractControl } from '@angular/forms';
import { RoleplayService, StepperContent } from '../../../service/roleplay/roleplay.service';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogComponent } from '../../confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-roleplay-step2',
    templateUrl: './roleplay-step2.component.html',
    styleUrl: '../../../../assets/css/roleplay.scss',
    standalone: false
})
export class RoleplayStep2Component {
  step2Form: FormGroup;
  sharedData: any = {};
  subscription: Subscription;
  color: string = '#e8e6e3';
  data: any = [];
  isEditMode: boolean;
  getData: any = {};
  formSubmitted = false;
  scenario_name: string = "";

  constructor(public Router: Router, private fb: FormBuilder, private sharedService: RoleplayService,
    private toastrService: ToastrService,private dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.sharedService.editMode$.subscribe(mode => {
      this.isEditMode = mode;
    });

    this.step2Form = this.fb.group({
      objectives: this.fb.array([], Validators.required),
      inputs: this.fb.array([])
    }, { validators: this.atLeastOneSelected.bind(this) });

    if (this.isEditMode) {
      this.sharedService.data$.subscribe({
        next: data => {
          this.data = data;
          const updatedMetaData = this.data[0].meta_data.filter(item => item.roleplay_metadata_type === 'objectives').map(items => {
            const { roleplay_metadata_val: name, id } = items;
            return { name, id }
          });
          this.scenario_name = this.data[0].scenario_name;
          const PreviousData = this.ifPreviousSelectedData();

          if (PreviousData.length) {
            this.setObjectives(PreviousData);
          } else {
            this.setObjectives(updatedMetaData);
          }
        },
        error: error => console.error('Error receiving data', error),
        complete: () => console.log('Data stream completed')
      });
    } else {

      this.subscription = this.sharedService.data$$.subscribe(response => {
        const PreviousData = this.ifPreviousSelectedData();
        if (PreviousData.length) {
          this.setObjectives(PreviousData);
        } else {
          this.setObjectives(response['objectives']);
        }

      }
      );
    }
  }

  atLeastOneSelected(formGroup: FormGroup): { [key: string]: boolean } | null {
    const objectives = formGroup.get('objectives') as FormArray;
    const isAtLeastOneSelected = objectives.controls.some(control => control.value);
    return isAtLeastOneSelected ? null : { atLeastOneRequired: true };
  }

  ifPreviousSelectedData() {
    if (this.sharedService.rolePlayScenarioData.roleplay_metadata.length) {
      const metaDataArray = this.sharedService.rolePlayScenarioData.roleplay_metadata;
      const objectiveMetaDataArray: any = metaDataArray.filter(data => {
        return data.type_name === "objectives";
      });
      const updatedData = objectiveMetaDataArray.map(item => {
        const { type_value } = item;
        return { name: type_value };
      });

      return updatedData;
    }
    return [];
  }

  groupByMetadataType() {
    return this.data[0].meta_data.reduce((acc, item) => {
      const { roleplay_metadata_type } = item;
      if (!acc[roleplay_metadata_type]) {
        acc[roleplay_metadata_type] = [];
      }
      const { id, roleplay_metadata_val: name } = item;
      acc[roleplay_metadata_type].push({ id, name });
      return acc;
    }, {});
  }

  get objectives(): FormArray {
    return this.step2Form.get('objectives') as FormArray;
  }

  setObjectives(objectives: any[]): void {
    const objectiveFGs = objectives.map(objective => this.fb.control(objective.name, Validators.required));
    const objectiveFormArray = this.fb.array(objectiveFGs);
    this.step2Form.setControl('objectives', objectiveFormArray);
  }

  get inputs() {
    return this.step2Form.get('inputs') as FormArray;
  }

  addInput() {
    this.inputs.push(this.fb.control(''));
  }

  addObjective(): void {
    this.objectives.push(this.fb.control(''));
  }

  removeObjective(index: number): void {
    this.objectives.removeAt(index);
  }

  removeInput(index: number): void {
    this.inputs.removeAt(index);
  }

  retainSelectedMetaData() {
    this.sharedService.rolePlayScenarioData.roleplay_metadata =
      this.sharedService.rolePlayScenarioData.roleplay_metadata.filter(item => item.type_name !== 'objectives');
    let objt = this.step2Form.value.objectives;
    if (objt.length > 0) {
      objt = objt.filter(item => item?.trim());
      objt.forEach(data => {
        this.sharedService.rolePlayScenarioData.roleplay_metadata.push(
          {
            type_name: "objectives",
            type_value: data
          }
        )
      })
    }
  }

  goToStep(id:number){
    this.formSubmitted = true;
    const stepper_data:StepperContent = this.sharedService.stepperContent.find(stepper=>stepper.stepId == id);
    this.changeStepper(stepper_data);
  }

  changeStepper(stepper_data: StepperContent) {
    console.log('Step2 : changeStepper: ', stepper_data);
    const current_step_id = 2;
    if (this.step2Form.valid || stepper_data.stepId < current_step_id) {
      this.retainSelectedMetaData();
      this.sharedService.changeStep(stepper_data);
    } else {
      this.toastrService.error('Invalid Form')
    }
  }
  goBack() {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: '350px',
        data: { message: 'You will lose all changes. Do you really want to leave?' }
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if (!result) {
          return;
        }
        this.Router.navigate(['/app-trainee-dasboard'], { skipLocationChange: true });
      });
    }
}
